import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=43775b5a&"
import script from "./GeneralInformation.vue?vue&type=script&lang=ts&"
export * from "./GeneralInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports